module.exports = {"511623100":"鼎屏镇","511623101":"城北镇","511623102":"城南镇","511623103":"柑子镇","511623105":"观音桥镇","511623106":"牟家镇","511623107":"合流镇","511623108":"坛同镇","511623109":"高滩镇","511623110":"九龙镇","511623111":"御临镇","511623112":"袁市镇","511623113":"丰禾镇","511623114":"八耳镇","511623115":"石永镇","511623116":"兴仁镇","511623117":"王家镇","511623118":"石滓镇","511623119":"三古镇","511623120":"两河镇","511623121":"太和镇","511623122":"椿木镇","511623123":"梁板镇","511623124":"复盛镇","511623125":"黎家镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511623.json
// module id = 2501
// module chunks = 0